const OWNER_EMAIL_VERIFIED_PREFIX = 'owner-email-verified:'

export function getOwnerEmailVerifiedKey(email: string) {
  return `${OWNER_EMAIL_VERIFIED_PREFIX}${String(email || '').trim().toLowerCase()}`
}

function getCookieDomain(hostname: string) {
  if (!hostname || hostname.includes('localhost')) {
    return null
  }

  const parts = hostname.split('.').filter(Boolean)
  if (parts.length < 2) {
    return null
  }

  return `.${parts.slice(-2).join('.')}`
}

export function persistOwnerEmailVerified(email: string) {
  const normalizedEmail = String(email || '').trim().toLowerCase()
  if (!normalizedEmail) {
    return
  }

  const key = getOwnerEmailVerifiedKey(normalizedEmail)
  window.localStorage.setItem(key, 'true')

  const cookieDomain = getCookieDomain(window.location.hostname)
  const cookieParts = [`${encodeURIComponent(key)}=true`, 'Path=/', 'Max-Age=7200', 'SameSite=Lax']

  if (cookieDomain) {
    cookieParts.push(`Domain=${cookieDomain}`)
  }

  if (window.location.protocol === 'https:') {
    cookieParts.push('Secure')
  }

  document.cookie = cookieParts.join('; ')
}

export function isOwnerEmailVerified(email: string) {
  const normalizedEmail = String(email || '').trim().toLowerCase()
  if (!normalizedEmail) {
    return false
  }

  const key = getOwnerEmailVerifiedKey(normalizedEmail)
  const localValue = window.localStorage.getItem(key)
  if (localValue === 'true') {
    return true
  }

  const encodedKey = encodeURIComponent(key)
  const cookies = document.cookie.split(';').map(item => item.trim())
  return cookies.some(cookie => cookie === `${encodedKey}=true`)
}
